import classNames from 'classnames/bind';
import React from 'react';

import styles from './common.module.scss';

import { FieldNumber } from '@/components/ui/kit/Field';

const cx = classNames.bind(styles);

const Item = ({ data: command }) => {
  return (
    <div className={cx('container')}>
      <label>
        Item Number
        <div className={cx('fieldWrapper')}>
          <FieldNumber value={command.data.item} readOnly />
        </div>
      </label>
      <label>
        Repeat
        <div className={cx('fieldWrapper')}>
          <FieldNumber value={command.data.repeat} readOnly />
        </div>
      </label>
    </div>
  );
};

export default Item;
